import { route } from "typesafe-react-router";

export const accountRoutes = {
    edit: route("account", "edit"),
    email: route("account", "email"),
    index: route("account"),
};
